import { combineReducers } from 'redux';
import inputFormSlice from './slices/input-form-slice';

export default combineReducers({
  inputFormSlice,
});
